<template>
  <div id="mapView">
    <div class="">

    </div>
  </div>
</template>

<script>
import { loadModules } from 'esri-loader';
import axios from 'axios'

export default {
  name: 'MapBays',
  data() {
    return {
      map: {},
      geoJsonData: {},
      geojsonLayer: {},
      geoJSONBusUrl: "http://gtfssample.geodemosolutions.com/gtfsbusbaysapi.php",
      geoJSONTrainUrl: "http://gtfssample.geodemosolutions.com/gtfstrainbaysapi.php",
      intervalTime: 1000*20,
      pollingInterval: {},
      gtfsBusLayerId: "",
      gtfsTrainLayerId: ""
    }
  },
  mounted() {
    const current = this
    loadModules([
      "esri/Map",
      "esri/layers/FeatureLayer",
      "esri/views/MapView",
      "esri/widgets/Home",
      "esri/layers/GeoJSONLayer",
      "esri/widgets/Legend",
      "esri/widgets/Expand",
      "esri/config",
      "esri/identity/IdentityManager",
      "esri/identity/OAuthInfo"],
      { css: true })
    .then(([
      ArcGISMap,
      FeatureLayer,
      MapView,
      Home,
      GeoJSONLayer,
      Legend,
      Expand,
      esriConfig,
      esriId,
      OAuthInfo,]) => {
      var portalURL = "https://arcadis.maps.arcgis.com"
      // esriConfig.portalUrl = portalURL
      //
      // var info = new OAuthInfo({
      //   appId: "qnPRWE39ygHdKNWl",
      //   portalUrl: portalURL,
      //   popup: false
      // });
      // esriId.registerOAuthInfos([info]);
      //
      // esriId
      //   .checkSignInStatus(portalURL + "/sharing/rest")
      //   .then(function() {
      //     esriId.getCredential(portalURL + "/sharing/rest");
      //     // displayItems();
      //     // var busStopsLayer = new FeatureLayer({
      //     //   url: "https://services6.arcgis.com/m84fmcvTQusi2jIj/arcgis/rest/services/GTFS_BUS_STOPS/FeatureServer",
      //     //   title: "Bus Stops"
      //     // });
      //     // current.map.add(busStopsLayer,0);
      //   })
      //   .catch(function(error) {
      //     console.log(error)
      //     esriId.getCredential(portalURL + "/sharing/rest");
      //   });


      current.map = new ArcGISMap({
        basemap: 'topo'
      });
      // console.log(this.$el);
      // 33.867190S 151.180690E for Bays
      this.view = new MapView({
        container: "mapView",
        map: current.map,
        center: [151.180690, -33.867190],
        zoom: 15.5
      });
      var homeWidget = new Home({
        view: this.view
      });

      this.view.ui.add(homeWidget, {
        position: "top-left",
        index: 0
      });

      // current.map.add(busStopsLayer,0);
      // console.log(busStopsLayer);
      current.createGeoJSONLayer()
      current.pollingInterval = setInterval(current.createGeoJSONLayer, current.intervalTime)

      const legendList = new Legend({
        view: this.view,
        layersInfos: [{
          layer: current.map.findLayerById(current.gtfsLayerId),
          title: ""
        }],
        label: "Realtime Bus Data"
      });
      const expandlegendList = new Expand({
          view: this.view,
          expanded: false,
          expandTooltip: "Legend",
          collapseTooltip: "Legend",
          content: legendList,
          group: "top-right"
      })
      this.view.ui.add(expandlegendList, {
        position: "top-right",
        index: 0
      });
      // console.log(pollingInterval);
      // current.createGeoJSONLayer()
      // const geoJSONUrl = "https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/all_month.geojson";
      // const geojsonLayer = new GeoJSONLayer({
        // url: geoJSONUrl,
        // copyright: "USGS Earthquakes",
        // popupTemplate: template,
        // renderer: renderer //optional
      // });
      // current.map.add(geojsonLayer);
    });
  },
  methods: {
    createGeoJSONLayer: function() {
      const current = this
      console.log("updating");
      loadModules(["esri/layers/GeoJSONLayer"],{ css: true })
      .then(([GeoJSONLayer]) => {

        const template = {
          title: "{ID}",
          content: "<b>Congestion Level:</b> {congestion_level}<br><b>Occupancy Status:</b> {occupancy_status}<br><b>Speed:</b> {speed}",
          // fieldInfos: [
          //   {
          //     fieldName: "DateTime",
          //     format: {
          //       dateFormat: "short-date-short-time"
          //     }
          //   }
          // ]
        };
        const colorVar = {
          type: "color",
          field: "speed",
          valueExpressionTitle: "Speed",
          stops: [
            {
              value: 0,
              color: "#f5422f"
            },
            {
              value: 10,
              color: "#f0ed32"
            },
            {
              value: 20,
              color: "#52eb34"
            }

          ]
        }
        const sizeVar = {
          type: "size",
          field: "occupancy_status_numeric",
          valueExpressionTitle: "Occupancy Status",
          stops: [
            {
              value: 0,
              size: 30,
              label: "Empty"
            },
            {
              value: 3,
              size: 9,
              label: "Moderate"
            },
            {
              value: 6,
              size: 5,
              label: "Full"
            }

          ]
        }
        const busRenderer = {
          type: "simple",
          symbol: {
            type: "simple-marker",
            outline: {
              // autocasts as new SimpleLineSymbol()
              color: [128, 128, 128],
              width: 0.5
            }
          },
          visualVariables: [
            colorVar,
            sizeVar
          ]
        };
        var trainSymbol = {
          type: "simple-marker",  // autocasts as new SimpleMarkerSymbol()
          style: "square",
          color: "black",
          size: "24px",  // pixels
          outline: {  // autocasts as new SimpleLineSymbol()
            color: [ 255, 255, 255 ],
            width: 3  // points
          }
        };
        const trainRenderer = {
          type: "simple", // autocasts as new SimpleRenderer()
          symbol: trainSymbol
        };
        const geoJsonBusLayer = new GeoJSONLayer({
          url: current.geoJSONBusUrl,
          copyright: "TfNSW Bus Data",
          // popupTemplate: template,
          title: "Realtime Bus Data for Bays Station",
          renderer: busRenderer
        });
        const geoJsonTrainLayer = new GeoJSONLayer({
          url: current.geoJSONTrainUrl,
          copyright: "TfNSW Train Data",
          // popupTemplate: template,
          title: "Realtime Light Rail Data for Bays Station",
          renderer: trainRenderer
        });
        console.log(current.gtfsBusLayerId);
        current.map.add(geoJsonBusLayer,1)
        current.map.remove(current.map.findLayerById(current.gtfsBusLayerId))
        current.gtfsBusLayerId = geoJsonBusLayer.id
        console.log(geoJsonBusLayer);
        console.log(current.gtfsTrainLayerId);
        current.map.add(geoJsonTrainLayer)
        current.map.remove(current.map.findLayerById(current.gtfsTrainLayerId))
        current.gtfsTrainLayerId = geoJsonTrainLayer.id
        console.log(geoJsonBusLayer);
        // current.map.layers.removeAll();
        // current.map.add(geoJsonLayer);
      });
    },
  },
  beforeDestroy() {
    if (this.view) {
      // destroy the map view
      this.view.container = null;
      clearInterval(this.pollingInterval)
    }
  },
  updated() {
    console.log(this.pollingInterval);
  }
};

</script>
<style scoped>
#mapView {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
}
</style>
